<template>
    <label class="cb-wrapper" :for="name">
        <slot />
        <input :id="id"
               :name="name"
               :checked="value"
               :disabled="disabled"
               type="checkbox"
               @change="$emit('input', $event.target.checked)">
        <span class="checkmark"></span>
    </label>
</template>

<script>
export default {
    name: 'AppCustomCheckbox',
    props: {
        id: {
            type: String,
            required: true
        },
        name: String,
        value: Boolean,
        disabled: Boolean,
    }
};
</script>
<style scoped>
.cb-wrapper {
    display: block;
    position: relative;
    padding-left: 27px;
    cursor: pointer;
    margin-bottom: 0px!important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
.cb-wrapper input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border-radius: 4px;
    background-color: #eee;
}
.cb-wrapper:hover input ~ .checkmark {
    background-color: #ccc;
}
.cb-wrapper input:checked ~ .checkmark {
    background-color: rgba(23, 162, 184, 0.85);
}
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}
.cb-wrapper input:checked ~ .checkmark:after {
    display: block;
}
.cb-wrapper .checkmark:after {
    left: 8px;
    top: 4px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>
